import React, { useEffect, useState } from "react";
import { makeStyles, useTheme, withStyles } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import CommonSearch from "./CommonSearch";
import {
  Delete,
  Label,
  List,
  PersonAdd,
  PersonAddDisabled,
} from "@material-ui/icons";
import {
  Avatar,
  Backdrop,
  Button,
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  IconButton,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Popover,
  Typography,
} from "@material-ui/core";
import Badge from "@material-ui/core/Badge";
import CoachService from "../../../../../Coach/coach_service";
import { useDispatch } from "react-redux";
import { showSnackbar } from "../../../../../../../Components/Snackbar/SnackbarActions";
import DataService from "../../../../../../../Service";

const useStyles = makeStyles((theme) => ({
  tabRoot: {
    borderWidth: 0,
    borderBottomWidth: 1,
    borderStyle: "solid",
    borderColor: "#ddd",
    "& .MuiTabs-flexContainer": {
      justifyContent: "flex-start",
    },
    "& .MuiTabs-indicator": {
      backgroundColor: "transparent",
    },
  },
  tabs: {
    "&.Mui-selected": {
      borderWidth: 0,
      borderBottomWidth: 1,
      borderStyle: "solid",
      borderColor:
        sessionStorage.getItem("role") == "admin"
          ? `${theme.palette.primary.main}`
          : "#981B1E",
      zIndex: 1,
      color:
        sessionStorage.getItem("role") == "admin"
          ? `${theme.palette.primary.main}`
          : "#981B1E",
    },
  },
  personAdd: {
    opacity: 1,
    fontSize: 30,
    borderRadius: 50,
    color: "#fff",
    backgroundColor: `${theme.palette.primary.main}`,
    padding: 10,
  },
}));

const StyledBadge = withStyles((theme) => ({
  badge: {
    right: 5,
    top: 5,
    border: `2px solid ${theme.palette.background.paper}`,
    padding: "0 4px",
  },
}))(Badge);

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && children}
    </Box>
  );
}

export default function CoachSearch(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { assignmentId } = props;
  const [value, setValue] = React.useState(0);
  const [searchFlag, setSearchFlag] = React.useState(false);
  const [totalCount, setTotalCount] = React.useState(1);
  const [coaches, setCoaches] = useState("");
  const [data, setData] = useState([]);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [selectedCoaches, setSelectedCoaches] = useState([]);
  const [busy, setBusy] = useState(null);

  const deleteCoachHandler = (id) => {
    // setIsLoading(true);
    CoachService.removeSelectedCoaches({
      search_list_id: id,
    }).then((response) => {
      // setCoachesCount((prevState) => prevState - 1);
      getSelectedCoaches();
    });
    //   .finally(() => setIsLoading(false));
  };

  const getSelectedCoaches = () => {
    CoachService.getSelectedCoaches({
      search_id: props.searchResultArr?.search_id,
      assignment_id: assignmentId,
    }).then((response) => {
      console.log("responseAdd", response);
      selectedCoaches.length = 0;
      setSelectedCoaches(selectedCoaches.concat(response.data));
    });
  };

  const addSelectedCoach = (id, userID, searchID) => {
    // setCurrentlyPickedCoachId(id);
    console.log("id, searchID", id, searchID);
    // setIsLoading(true);

    CoachService.addSelectedCoaches({
      partner_profile_id: id,
      search_id: searchID,
      search_type: "External",
      assignment_id: assignmentId,
    }).then((response) => {
      console.log(response);
      // setCoachesCount((prevState) => prevState + 1);
      getSelectedCoaches();
    });
    //   .finally(() => setIsLoading(false));
  };

  const tabArr = ["All", "Best Match", "Partial Match"];
  const tabPanelArr = [
    <CommonSearch
      searchResultArr={props.searchResultArr}
      assignmentId={assignmentId}
      //   setSelectedCoaches={setSelectedCoaches}
      selectedCoaches={selectedCoaches}
      deleteCoachHandler={deleteCoachHandler}
      getSelectedCoaches={getSelectedCoaches}
      addSelectedCoach={addSelectedCoach}
      type="result"
    />,
    <CommonSearch
      searchResultArr={props.searchResultArr}
      assignmentId={assignmentId}
      //   setSelectedCoaches={setSelectedCoaches}
      selectedCoaches={selectedCoaches}
      deleteCoachHandler={deleteCoachHandler}
      getSelectedCoaches={getSelectedCoaches}
      addSelectedCoach={addSelectedCoach}
      type="best_match"
    />,
    <CommonSearch
      searchResultArr={props.searchResultArr}
      assignmentId={assignmentId}
      //   setSelectedCoaches={setSelectedCoaches}
      selectedCoaches={selectedCoaches}
      deleteCoachHandler={deleteCoachHandler}
      getSelectedCoaches={getSelectedCoaches}
      addSelectedCoach={addSelectedCoach}
      type="partial_match"
    />,
  ];

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    console.log(`props.searchResultArr`, props.searchResultArr);
    Object.keys(props.searchResultArr).length > 0
      ? getSelectedCoaches()
      : getSearchId();
  }, []);

  const getSearchId = () => {
    DataService.getDirectData(
      "searches/find_search?search_type=External&assignment_id=" + assignmentId,
      {}
    ).then((response) => {
      CoachService.getSelectedCoaches({
        search_id: response.search_id,
        assignment_id: assignmentId,
      }).then((response) => {
        setSelectedCoaches(response.data);
      });
    });
  };
  console.log("selected", selectedCoaches);
  const listSaveHandler = () => {
    console.log("selected", selectedCoaches);
    if (!selectedCoaches.length) return;
    setBusy("saving-list");

    const data = selectedCoaches?.map((coach) => ({ coach_id: coach.user_id }));
    console.log("data", data);
    CoachService.saveSelectedCoaches({
      assignment_id: assignmentId,
      longlist_coaches: data,
    })
      .then((res) => {
        if (res.success) {
          dispatch(showSnackbar("success", ["List saved successfully"]));
          props.setSearchFlag(false);
        } else {
          dispatch(showSnackbar("error", "Something went wrong!"));
        }
      })
      .catch((err) => {
        dispatch(showSnackbar("error", err.errors));
      })
      .finally(() => setBusy(null));
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  return (
    <>
      <Grid
        container
        direction="row"
        justify="center"
        alignItems="center"
        style={{ position: "relative" }}
      >
        <Grid item xs={12}>
          <Box my={5}>
            <Tabs
              value={value}
              onChange={handleChange}
              classes={{ root: classes.tabRoot }}
            >
              {tabArr.map((option) => (
                <Tab
                  variant="contained"
                  classes={{ root: classes.tabs }}
                  label={option}
                />
              ))}
            </Tabs>
            {tabPanelArr.map((option, index) => (
              <TabPanel value={value} index={index}>
                {option}
              </TabPanel>
            ))}
          </Box>
        </Grid>

        {/* selected coach list */}
        <Grid item xs={2}>
          <Box
            display="inline"
            px={1}
            py={3}
            style={{ position: "absolute", top: "24px", right: 0 }}
          >
            <IconButton aria-label="cart" onClick={handleClick}>
              <StyledBadge
                badgeContent={selectedCoaches?.length}
                color="secondary"
              >
                <PersonAdd className={classes.personAdd} />
              </StyledBadge>
            </IconButton>
            <Popover
              id={id}
              open={open}
              anchorEl={anchorEl}
              onClose={handleClose}
              anchorOrigin={{ vertical: "center", horizontal: "left" }}
              transformOrigin={{ vertical: "top", horizontal: "right" }}
            >
              <Box width={250}>
                <Grid
                  container
                  direction="row"
                  justify="center"
                  alignItems="center"
                  style={{ position: "relative" }}
                >
                  <Grid item xs={12}>
                    <Typography style={{ color: "#fff", fontWeight: "bold" }}>
                      <Box bgcolor="#077f837a" p={2}>
                        Longlist coach
                      </Box>
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Box p={1}>
                      {selectedCoaches?.map((coach, index) => {
                        return (
                          <Box py={1} key={`${coach?.id}-${index}`}>
                            <Grid
                              container
                              direction="row"
                              justify="center"
                              alignItems="center"
                              spacing={1}
                            >
                              <Grid item xs={2}>
                                <Box>
                                  <Avatar
                                    className={classes.userModelPic}
                                  ></Avatar>
                                </Box>
                              </Grid>
                              <Grid item xs={8}>
                                <Typography>
                                  <Box ml="10px" fontSize="14px">
                                    {coach?.name}
                                  </Box>
                                </Typography>
                              </Grid>
                              <Grid item xs={2} style={{ textAlign: "right" }}>
                                <Delete
                                  onClick={() => {
                                    deleteCoachHandler(coach?.id);
                                  }}
                                  style={{ cursor: "pointer" }}
                                  className={classes.userModelIcon}
                                />
                              </Grid>
                            </Grid>
                          </Box>
                        );
                      })}
                    </Box>
                  </Grid>
                  <Grid item xs={12}>
                    <Box p={1} textAlign="right">
                      <Button
                        disableElevation
                        variant="contained"
                        color="secondary"
                        style={{ fontSize: "12px", textTransform: "none" }}
                        onClick={listSaveHandler}
                      >
                        Save and proceed
                      </Button>
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </Popover>
          </Box>
        </Grid>
      </Grid>
    </>
  );
}
